function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 6",
    transform: "translate(8.5 1.5)",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M0 0v14"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    transform: "translate(1.5 8.5)",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M0 0h14"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6612122c1bf7c9267d6313346f6c43b1.svg";
export { ForwardRef as ReactComponent };